<template>
   <div class="row">

        <div class="col-md-12 card">

          <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                  <h3 class="title">{{$t('reports')}}</h3>
                </div>
                <div class="col-md-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm"
                      :placeholder="$t('search')"
                      v-model="search"
                      addon-right-icon="nc-icon nc-zoom-split" ></fg-input>
                  </div>
                </div>
            </div>
          </div>

          <div class="card-body">
              <div class="row">
                  <div v-for="(rep, index) in paginated" :key="index" class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
                    <div class="report mb-5" v-if="rep.permissions.includes(userType)">
                       <router-link class="link" :to="rep.link">{{ rep.name }}</router-link>
                    </div>
                  </div>
              </div>
          </div>

        </div>

   </div>
</template>
<script>
  export default{
     data() {
       return {
         search:'',
         reports:[
           {id:1,name:"Trainers",link:"/report/trainer", permissions: ['Super Admin', 'Manager', 'Admin']},
           {id:2,name:"Farmers",link:"/report/farmers", permissions: ['Super Admin', 'Manager', 'Admin', 'Trainer']},
           {id:3,name:"Harvests",link:"/report/harvest", permissions: ['Super Admin', 'Manager', 'Admin', 'Trainer']},
           {id:4,name:"Activations",link:"/report/activation", permissions: ['Super Admin', 'Manager', 'Admin']},
         ],
         pagination:{
            perPage: 10,
            perPageOptions: [10, 20, 30, 60, 500, 1000],
            currentPage:1,
            nextPage:'',
            prevPage:'',
            total:'',
            from:'',
            to:'',
            page:'',
          },
          user: localStorage.getItem("user"),
          userType:'',
       }
     },
     mounted() {
        this.authUser = JSON.parse(this.user);
        this.userType = this.authUser[0].roleName;
     },
     methods: {

      paginate(array, length, pageNumber){
          this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
          this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
          this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
          this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
          this.pagination.page = Math.ceil(array.length / length);
          this.pagination.total = array.length;
          return array.slice((pageNumber - 1) * length, pageNumber * length);
      },

     },

     computed: {
       filterReport() {
            let result = this.reports;
            if (this.search) {
                result = result.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1);
                    })
                })
            }
            return result;
        },

        paginated(){
            return this.paginate(this.filterReport, this.pagination.perPage, this.pagination.currentPage);
        },

     },
  }
</script>
<style scoped>
  .report {
    border: 2px solid #9F9F9F;
    padding: 20px;
    border-radius: 5px;
    color: #030303;
    font-size: 20px;
    height: 150px;
    display: flex;
    justify-content: center;
  }

  .report a{
    text-decoration: none;
    color:black;
    align-items: center;
    justify-content: center;
    display: flex;
    font-weight: bolder;
  }

  .report a:hover{
    color: #FFBD40;
  }
</style>
